export default __webpack_public_path__ + "static/lgbtq-belmond-vid-677b87a75b196e00d8d24a6c568a7f77.jpg";